<script lang="ts" setup>
import { cn } from '@/utils';
import { getBoldMatchCaracteres, sanitize } from '~~/utils';
import type { GroupItemClickEvent, GroupProps, Item } from '.';

const props = withDefaults(defineProps<GroupProps>(), {
	isSelection: false
});

const groupEventBus = useEventBus<GroupItemClickEvent>('group-item-click');

function getSubText(item: Item) {
	const state = sanitize(props.state);

	if (props.groupKey !== 'region' || !('data' in item)) return state;

	const city = getBoldMatchCaracteres(item.data.city, props.searchTerm);

	return `${city} - ${state}`;
}

function handleGroupItemClick(item: Item) {
	groupEventBus.emit({
		item,
		groupKey: props.groupKey
	});
}
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
	<CommandGroup class="p-0">
		<template #heading>
			<div
				:class="
					cn(
						'flex h-12 cursor-default items-center gap-3 px-4 font-matter-sq text-lg font-normal leading-normal tracking-[-0.36px] text-primary',
						groupHeadingClasses
					)
				"
			>
				<component :is="heading.icon" :class="cn('size-5', groupIconClasses)" />

				{{ heading.text }}
			</div>
		</template>

		<CommandItem
			v-for="item in groupItems"
			:key="`suggest-group-${groupKey}-${item.label}`"
			:value="{
				group: groupKey,
				groupData: item
			}"
			:class="
				cn(
					'flex flex-col items-start py-2 pl-12 pr-4 data-[highlighted]:bg-white-dark-2',
					groupItemWrapperClasses
				)
			"
			@click="handleGroupItemClick(item)"
		>
			<div class="contents">
				<p
					:class="
						cn(
							'text-start text-base font-normal leading-normal text-primary',
							groupItemTextClasses
						)
					"
					v-html="getBoldMatchCaracteres(item.label, searchTerm)"
				/>
				<small
					:class="
						cn(
							'text-start text-xs font-normal leading-normal text-primary-light-2',
							groupItemSubTextClasses
						)
					"
					v-html="getSubText(item)"
				>
				</small>
			</div>
		</CommandItem>
	</CommandGroup>
</template>
